import React, { useMemo, useState } from 'react';
import { BuildingIcon, SearchIcon, XIcon } from 'lucide-react';
import { possibleBuyers } from '../data/possibleBuyers';
export function PossibleBuyers() {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    if (!query.trim()) return possibleBuyers;
    const q = query.toLowerCase();
    return possibleBuyers.filter(name => name.toLowerCase().includes(q));
  }, [query]);
  return <div className="min-h-screen bg-white" data-id="element-2235">
      {/* Header */}
      <header className="bg-slate-50 border-b border-slate-200" data-id="element-2236">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-2237">
          <div className="flex items-center gap-3 mb-4" data-id="element-2238">
            <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center" data-id="element-2239">
              <BuildingIcon className="w-5 h-5 text-amber-600" data-id="element-2240" />
            </div>
            <span className="text-sm font-semibold text-amber-600 uppercase tracking-wider" data-id="element-2241">
              Transparency
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-3 tracking-tight" data-id="element-2242">
            Possible Buyers
          </h1>
          <p className="text-slate-600 max-w-3xl leading-relaxed" data-id="element-2243">
            When you submit a form on findservicequotes.io, your contact
            information may be shared with one or more of the home service
            companies, contractors, and affiliated partners listed below. This
            list is provided for transparency and may change over time.
          </p>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-2244">
        {/* Search */}
        <div className="mb-8" data-id="element-2245">
          <div className="relative" data-id="element-2246">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" data-id="element-2247" />
            <input type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search companies…" className="w-full h-14 pl-12 pr-12 bg-slate-50 border-2 border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100 transition-all" data-id="element-2248" />
            {query && <button onClick={() => setQuery('')} aria-label="Clear search" className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full hover:bg-slate-200 flex items-center justify-center text-slate-500 transition-colors" data-id="element-2249">
                <XIcon className="w-4 h-4" data-id="element-2250" />
              </button>}
          </div>
          <p className="mt-3 text-sm text-slate-500" data-id="element-2251">
            Showing{' '}
            <span className="font-semibold text-slate-700" data-id="element-2252">
              {filtered.length.toLocaleString()}
            </span>{' '}
            of{' '}
            <span className="font-semibold text-slate-700" data-id="element-2253">
              {possibleBuyers.length.toLocaleString()}
            </span>{' '}
            companies
          </p>
        </div>

        {/* List */}
        {filtered.length > 0 ? <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc list-inside marker:text-amber-500" data-id="element-2254">
            {filtered.map(name => <li key={name} className="text-slate-700 text-sm leading-relaxed break-words" data-id="element-2255">
                {name}
              </li>)}
          </ul> : <div className="text-center py-16" data-id="element-2256">
            <p className="text-slate-500" data-id="element-2257">
              No companies match &ldquo;{query}&rdquo;.
            </p>
          </div>}

        {/* Footnote */}
        <div className="mt-16 pt-8 border-t border-slate-200" data-id="element-2258">
          <p className="text-xs text-slate-500 leading-relaxed" data-id="element-2259">
            This list represents matched companies and may include but is not
            limited to those shown. Buyers, partners, and affiliations may be
            added or removed at any time. For questions about how your
            information is shared, please see our{' '}
            <a href="/privacy-policy" className="text-amber-600 hover:underline font-medium" data-id="element-2260">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </main>
    </div>;
}